<base-modal-component class="base-modal" (onConfirm)="save()">
    <input class="form-control selectx"
           [(ngModel)]="message"/>
</base-modal-component>
